import { useQuery } from 'react-query';
import CardRelatorio from './CardRelatorio';
import Valor from './Valor';
import axios from 'axios';
import Skeleton from '../../components/layout/Skeleton';
import { dateWithoutTimezone } from '../../lib/util';
import { translateFilter } from './util';

type Props = {
  periodo: [string, string, string];
  canal_id: number[];
};

const CardRelatorioTotalAtendimentosHumanos = ({
  periodo,
  canal_id,
}: Props) => {
  const q = useQuery(
    ['totalAtendimentosHumanos', periodo, canal_id],
    async () => {
      const qs = new URLSearchParams();
      qs.append('facts', 'qtd_atendimentos_humanos');
      qs.append('filter', translateFilter({ periodo, canal_id }));

      const res = await axios.get(
        '/api/relatorios/chat_mensagem?' + qs.toString(),
      );
      return res.data.result[0].qtd_atendimentos_humanos ?? 0;
    },
    { refetchOnWindowFocus: false },
  );

  return (
    <CardRelatorio
      titulo="Atend. Humano"
      mostrarVisualizador={true}
      filtroVisualizador={{ periodo, canal_id }}
      metricasVisualizador={['qtd_atendimentos_humanos']}
      dimensoesVisualizador={['usuario_responsavel_nome']}
      hrefVisualizador="/api/relatorios/chat_mensagem"
      info="Quantidade de atendimentos realizados por atendentes humanos no período, para o mesmo cliente ou não."
      csv
    >
      {q.isFetching ? <Skeleton format="box" /> : <Valor valor={q.data} />}
    </CardRelatorio>
  );
};

export default CardRelatorioTotalAtendimentosHumanos;
